<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <q-card class="GeolocationMockBlockedDialog">
      <h2 class="GeolocationMockBlockedDialog-title">
        {{ $t('geolocation.mock_blocked_title') }}
      </h2>

      <p class="GeolocationMockBlockedDialog-message">
        {{ $t('geolocation.mock_blocked') }}
      </p>

      <p class="GeolocationMockBlockedDialog-message GeolocationMockBlockedDialog-message--note">
        {{ $t('geolocation.mock_blocked_note') }}
      </p>

      <div class="GeolocationMockBlockedDialog-actions">
        <q-btn
          :label="$t('geolocation.mock_blocked_ok')"
          @click="onDialogOK"
          class="GeolocationMockBlockedDialog-button"
          color="binnacle-red"
          outline
          rounded
          no-caps
        />
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
  // Quasar
  import { useDialogPluginComponent } from 'quasar'

  export default {
    name: 'GeolocationMockBlockedDialog',
    emits: [...useDialogPluginComponent.emits],
    setup () {
      // Contrato del Dialog plugin de Quasar: dialogRef + onDialogHide gobiernan el ciclo del QDialog
      // (lo abre Dialog.create), onDialogOK cierra al confirmar. persistent obliga a usar el boton.
      const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

      return { dialogRef, onDialogHide, onDialogOK }
    }
  }
</script>

<style lang="scss" scoped>
  .GeolocationMockBlockedDialog {
    width: 100%;
    max-width: 420px;
    padding: 32px 28px;
    border-radius: 16px;
    text-align: center;

    &-title {
      margin: 0 0 20px;
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 1.3;
      color: #1d1d1d;
    }

    &-message {
      margin: 0 0 16px;
      font-size: 1rem;
      line-height: 1.5;
      color: #5c5c5c;

      &--note {
        margin-bottom: 24px;
      }
    }

    &-actions {
      display: flex;
      justify-content: center;
    }

    &-button {
      min-width: 180px;
      padding: 6px 24px;
      font-weight: 700;
    }
  }
</style>
